// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cL-z","smallCardRow":"dL-z","largeCardRow":"eL-z","productSearchRow":"fL-z","curatedRow":"gL-z"};